const Languages = [
  { id: 0, countryCode: '', country: 'Choose your language', locale: 'eng' },
  {
    id: 1,
    countryCode: 'US',
    locale: 'en',
    country:'English'
  },
  {
    id: 2,
    countryCode: 'DE',
    locale: 'de',
    country:'German'
  },
  {
    id: 4,
    countryCode:'FR',
    locale:'fr',
    country:'French'
  },
  {
    id: 5,
    countryCode: 'ES',
    locale: 'es',
    country:'Spanish'
  }/*,{
    id: 3,
    countryCode:'IT',
    locale:'it',
    country:'Italian'
  },*/
];
export default Languages